import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as reportGeneration from '../../../../../redux/reportGeneration';
import ProjectLevelPreview from '../projectLevel/Preview';
import ReleaseGroupPreview from '../releaseGroupLevel/Preview';
import type { ReportExclusionOptions, ReportGenerationParams } from '../../shared/types';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, IncludeFixPlanFilterOption } from '../shared/types';

import styles from './Preview.module.less';

type Props = {
  params: ReportGenerationParams;
  format: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  excludeOptions: ReportExclusionOptions;
  fixPlanOptions: IncludeFixPlanFilterOption[];
  authorName?: string;
  authorEmail?: string;
  supplier?: string;
};

const Preview: VoidFunctionComponent<Props> = (props: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);

  return (
    <div className={styles.preview}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {projectType === 'project' ? <ProjectLevelPreview {...props} /> : <ReleaseGroupPreview {...props} />}
    </div>
  );
};

export default Preview;
